import MessageModal from '@/components/MessageModal';
import DoronPurchaseModal from '@/components/DoronPurchaseModal';

export function alert(vue, title, message, closeFunction) {
  openMessageDialog(vue, title, message, "alert", closeFunction);
}

export function confirm(vue, title, message, closeFunction = null, submitFunction = null) {
  openMessageDialog(vue, title, message, "confirm", closeFunction, submitFunction);
}

export function openPointLackModal(vue, message = "ゴールドが不足しています。<br/>ゴールドを購入しますか？", callback = null) {
  openMessageDialog(vue, "ゴールド不足", message, "confirm", () => {
    if (callback) callback(false);
  }, () => {
    openDoronPurchaseModal(vue, callback);
  });
}

export function openDoronPurchaseModal(vue, callback = null) {
  openDialog(vue, DoronPurchaseModal, {
    parent: vue
  }, {
    submit() {
      if (callback) callback(true);
    },
    close() {
      if (callback) callback(false);
    }
  });
}

function openMessageDialog(vue, title, message, type, closeFunction = null, submitFunction = null) {
  openDialog(vue, MessageModal, {
    title: title,
    message: message,
    type: type
  },{
    submit() {
      if (submitFunction) submitFunction();
    },
    close() {
      if (closeFunction) closeFunction();
    }
  })
}

function openDialog(vue, component, props, events) {
  vue.$buefy.modal.open({
    component: component,
    parent: vue,
    hasModalCard: true,
    trapFocus: true,
    canCancel: false,
    props: props,
    events: events
  });
}